import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

import {
  partnerWalletStatementBalance,
  partnerWalletStatementAll,
  partnerMyOwnWalletBalance,
  partnerMyOwnWalletStatementAll
} from "@/services/walletstatement.js";

@Module({
  namespaced: true
})
export default class WalletStatement extends VuexModule {
  //state

  walletStatementData = {};
  partnerWalletStatementData = {};
  partnerWalletBalance={};
  walletBalance={}

  //Action

  // partner my own //
  @Action
  public async partnerMyOwnWalletBalance(payload) {
    try {
      const data = await partnerMyOwnWalletBalance(payload);
      this.context.commit("setPartnerMyOwnWalletBalance", data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchPartnerMyOwnWalletListAll(payload) {
    try {
      const data = await partnerMyOwnWalletStatementAll(payload);
      this.context.commit("setPartnerMyOwnWalletList", data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  // partner by tenant //
  @Action
  public async fetchWalletBalance(payload) {
    try {
      const data = await partnerWalletStatementBalance(payload);
      this.context.commit("setWalletBalanceAll", data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchWalletListAll(payload) {
    try {
      const data = await partnerWalletStatementAll(payload);
      this.context.commit("setWalletList", data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  //Mutation

  // partner my own //
  @Mutation
  public setPartnerMyOwnWalletList(data: any) {
    this.partnerWalletStatementData = data;
  }
  @Mutation
  public setPartnerMyOwnWalletBalance(data: any) {
    this.partnerWalletBalance = data;
  }

  // partner by tenant //
  @Mutation
  public setWalletList(data: any) {
    this.walletStatementData = data;
  }
  @Mutation
  public setWalletBalanceAll(data: any) {
    this.walletBalance = data;
  }
  //getter
  // partner my own //
  get GetPartnerMyOwnWalletList() {
    return this.partnerWalletStatementData;
  }
  get GetWalletBalance() {
    return this.partnerWalletBalance;
  }

  // partner by tenant //
  get GetWalletList() {
    return this.walletStatementData;
  }
  get GetWalletBalanceAll() {
    return this.walletBalance;
  }
  
}
